<template>
  <div class="landing_about_avgl">
    <div class="landing_about_header_avgl">Welcome to AVGL!</div>
    <div class="landing_about_sub_header_avgl">Choose your path and experience the best of academic esports</div>
    <div class="landing_about_classes">
      <div class="landing_about_class">
        <div class="class_img college" />
        <div class="class_group">
          <div class="class_title">College Students</div>
          <div class="class_button" @click="showModalAvglRegister('college')">Get Started</div>
        </div>
      </div>
      <div class="landing_about_class">
        <div class="class_img highschool" />
        <div class="class_group">
          <div class="class_title">K-12 Students</div>
          <div class="class_button" @click="showModalAvglRegister('high_school')">Get Started</div>
        </div>
      </div>
      <div class="landing_about_class">
        <div class="class_img admin" />
        <div class="class_group">
          <div class="class_title">Teachers / Administrators </div>
          <div class="class_button" @click="showModalAvglRegister('none_student')">Get Started</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { EventBus, SHOW_MODAL_ONBOARDING_VERIFY } from '../../../event-bus';

export default {
  mixins: [component],
  methods: {
    showModalAvglRegister(typeRegister) {
      EventBus.$emit(SHOW_MODAL_ONBOARDING_VERIFY, null, typeRegister);
    },
  },
};
</script>
